import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront'
import { CustomAddedToCartDialogComponent } from './custom-added-to-cart-dialog.component'

export const customAddedToCartLayoutConfig: LayoutConfig = {
  launch: {
    CUSTOM_ADDED_TO_CART: {
      inlineRoot: true,
      component: CustomAddedToCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
}
